const dateToString = (date: Date) => `${date.getMonth() + 1}.${date.getDate()}.${date.getFullYear().toString().slice(2)}`;

export default dateToString;
